import { SvgIcon, SvgIconProps, useTheme } from "@mui/material";

export const Pause = (props: SvgIconProps) => {
  const theme = useTheme();
  return (
    <SvgIcon viewBox="0 0 384 512" {...props}>
      <path
        opacity={0.2}
        d="M32 112l0 288c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16l0-288c0-8.8-7.2-16-16-16L48 96c-8.8 0-16 7.2-16 16zm176 0l0 288c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16l0-288c0-8.8-7.2-16-16-16l-48 0c-8.8 0-16 7.2-16 16z"
      />
      <path
        fill={props.htmlColor || theme.palette.secondary[500]}
        d="M48 96c-8.8 0-16 7.2-16 16l0 288c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16l0-288c0-8.8-7.2-16-16-16L48 96zM0 112C0 85.5 21.5 64 48 64l48 0c26.5 0 48 21.5 48 48l0 288c0 26.5-21.5 48-48 48l-48 0c-26.5 0-48-21.5-48-48L0 112zM224 96c-8.8 0-16 7.2-16 16l0 288c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16l0-288c0-8.8-7.2-16-16-16l-48 0zm-48 16c0-26.5 21.5-48 48-48l48 0c26.5 0 48 21.5 48 48l0 288c0 26.5-21.5 48-48 48l-48 0c-26.5 0-48-21.5-48-48l0-288z"
      />
    </SvgIcon>
  );
};
